import { render } from "./resumenCards.vue?vue&type=template&id=13e0e27d&scoped=true"
import script from "./resumenCards.vue?vue&type=script&lang=js"
export * from "./resumenCards.vue?vue&type=script&lang=js"

import "./resumenCards.vue?vue&type=style&index=0&id=13e0e27d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e0e27d"]])

export default __exports__